
















































































































import * as _ from "lodash";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getTongueMessages } from "@/request/idr";
import Copy from "@/components/copy.vue";
import Pagination from "@/components/paginaiton.vue";
import SelectMultiSearch from "../../components/select-multi-search.vue";
@Component({
  components: {
    Copy,
    Pagination,
    SelectMultiSearch
  }
})
export default class IdrTongueContent extends Vue {
  @Prop()
  private selectedTongues: any;
  private filters: any = {
    姓名: "",
    西医疾病: [],
    中医疾病: [],
    中医证型: [],
    分组标签: [],
    time: [],
    标注: "全部"
  };
  private messages: any[] = [];
  // 翻页
  private ifLoading: boolean = false;
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  private pageSize: any = 10;
  // 排序
  private cSortField: string = "检测时间";
  private cSortValue: number = 0;
  @Watch("selectedTongues", { immediate: true, deep: true })
  private selectedTongueChange() {
    this.calIfTonguesSelected();
  }
  /**
   * @description 搜索
   */
  private search() {
    if (this.filters.time.length > 0) {
      this.filters["开始时间"] = this.filters.time[0];
      this.filters["结束时间"] = this.filters.time[1];
    }
    this.filters["order_value"] = this.cSortValue;
    // console.log(this.filters);
    const params = _.cloneDeep(this.filters);
    params.current_page = this.currentPage;
    params.page_count = this.pageSize;
    getTongueMessages(this, params).then((data: any) => {
      this.$set(this, "messages", data.tongues);
      this.totalPage = data.total_page;
      this.totalCount = data.total_count;
      this.calIfTonguesSelected();
    });
  }
  /**
   * @description 标记变化
   */
  private biaojiChange(val) {
    this.currentPage = 1;
    this.search();
  }
  /**
   * @description 排序变化
   */
  private changeSort() {
    this.cSortValue = this.cSortValue === 0 ? 1 : 0;
    this.currentPage = 1;
    this.search();
  }
  /**
   * @description 重置搜索条件
   */
  private resetFilter() {
    this.filters = {
      姓名: "",
      西医疾病: [],
      中医疾病: [],
      中医证型: [],
      分组标签: [],
      time: [],
      标注: "全部"
    };
    this.cSortValue = 0;
  }
  /**
   * @description 重置搜索
   */
  private reset() {
    this.currentPage = 1;
    this.resetFilter();
    this.search();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.search();
  }
  /**
   * @description 切换选中比对的舌图
   */
  private triggerSelectedTongue(message) {
    this.$emit("trigger", message);
  }
  /**
   * @description 判断当前页面的舌图是否被选中
   */
  private calIfTonguesSelected() {
    this.messages.forEach((message: any, messageIndex: any) => {
      const index = _.findIndex(this.selectedTongues, (item: any) => {
        return item.tongue_id === message.tongue_id;
      });
      if (index !== -1) {
        this.$set(this.messages[messageIndex], "selected", true);
      } else {
        this.$set(this.messages[messageIndex], "selected", false);
      }
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.search();
  }
}
